import React, { useState, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import { Button, CardActionArea, Skeleton } from "@mui/material";
import Toast from "../../utils/Toast";
import LoadingCircle from "../../utils/LoadingCircle";
import { HttpMainApi } from "../../interface/main-api";
import { userState } from "../../interface/MainInterface";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import "react-calendar/dist/Calendar.css";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { getFormattedDateTime } from "../../utils/getFormattedDateTime";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import MobileMainFooter from "./MobileMainFooter";
interface propsType {
  userState: userState;
}
interface ReservationDetails {
  userName: string;
  userId: string;
  inputDt: string;
  reservDt: string;
  reservOption: string;
  deviceNum: string;
}

interface Reservations {
  [key: string]: ReservationDetails;
}

interface ReservationInfo {
  sk: string;
  pk: string;
  userId: string;
  reservations: Reservations;
}

interface Reservation {
  sk: string;
  pk: string;
  userId: string;
  reservInfo: ReservationInfo;
  reservState: string;
}
const mainApi = new HttpMainApi();
const ROBOT_CLEANER_PATH = "/reservationrobotcleaner";
const SMALL_LIBRARY_PATH = "/mobilebooktemplate";
const SMALL_LIBRARY_EVENT_TYPE = "SMALL_LIBRARY_MENU_CLICK";
const COMMUNITY_CENTER_HERO_IMAGES = [
  "/images/hpoint-renewal/community/community-center-hero-variant-01-star-swirl.png",
  "/images/hpoint-renewal/community/community-center-hero-variant-02-sunburst.png",
  "/images/hpoint-renewal/community/community-center-hero-variant-03-shooting-star.png",
  "/images/hpoint-renewal/community/community-center-hero-variant-04-orbit.png",
  "/images/hpoint-renewal/community/community-center-hero-variant-05-sparkle.png",
];
const HEALTH_ROLLING_MESSAGES = [
  "💪 천국의 계단, 오늘도 한 걸음 더",
  "🧘 전동 거꾸리로 시원하게 리프레시",
  "📊 인바디로 내 몸 변화를 체크해요",
  "🏋️ 파워랙에서 더 강해지는 중",
  "🏃 러닝머신 위, 나만의 페이스 완주",
  "✨ 꾸준한 운동이 만드는 건강한 하루",
];
interface Book {
  rank: number;
  title: string;
  author: string;
  image: string;
  badge?: string;
  tag?: string;
  description?: string;
  url?: string;
  maincopy?: string;
  isBorrowed?: boolean;
}
const MobileMainPage = (props: propsType) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [reservationGolf, setReservationGolf] = useState<Reservation[]>([]);
  const [reservationStudy, setReservationStudy] = useState<Reservation[]>([]);
  const [reservationHealth, setReservationHealth] = useState<Reservation[]>([]);
  const [reservationLocker, setReservationLocker] = useState<Reservation[]>([]);
  const [golfNoData, setGolfNoData] = useState(true);
  const [studyNoData, setStudyNoData] = useState(true);
  const [healthNoData, setHealthNoData] = useState(true);
  const [lockerNoData, setLockerNoData] = useState(true);
  const [isReservationStatusReady, setIsReservationStatusReady] = useState(false);
  const [lockerHPassword, setLockerHPassword] = useState("");
  const [lockerGPassword, setLockerGPassword] = useState("");
  const [bookList, setBookList] = useState<Book[]>([]);
  const [isBookLoading, setIsBookLoading] = useState(true);
  const [sklist, setSklist] = useState<string[]>([]);
  const [communityCenterHeroImage] = useState(
    () => COMMUNITY_CENTER_HERO_IMAGES[Math.floor(Math.random() * COMMUNITY_CENTER_HERO_IMAGES.length)]
  );
  const navigate = useNavigate();

  const icons = [
    {
      label: "헬스장",
      src: "/images/icon-gym.png",
      to: "/reservationhealth",
    },
    {
      label: "골프",
      src: "/images/icon-player.png",
      to: "/reservationgolf",
    },
    {
      label: "독서실",
      src: "/images/icon-studying.png",
      to: "/reservationstudy",
    },

    {
      label: "락커룸",
      src: "/images/icon-lockers.png",
      to: "/reservationlocker",
    },
  ];
  const robotCleanerOpenAt = new Date(2026, 5, 1, 0, 0, 0);
  const robotCleanerBadgeText = new Date() < robotCleanerOpenAt ? "6월 1일 오픈" : "예약 접수 중";

  const sendMainEntryClickLog = (eventType: string, path: string) => {
    void mainApi
      .put_dashboard_event({
        eventType,
        userId: props.userState.userId,
        userName: props.userState.userName,
        userDong: props.userState.userDong,
        userHo: props.userState.userHo,
        path,
        source: "MOBILE_MAIN",
      })
      .catch(() => undefined);
  };

  const get_my_reservation1 = async () => {
    setIsLoading(true);

    const { formatmonthpk } = getFormattedDateTime();
    const userId = props.userState.userId;
    const pk = userId;
    const sk = formatmonthpk;
    const param: any = {
      pk: pk,
      sk: sk,
      reservState: "신청",
      reservFilter: "GOLF",
    };
    const res = await mainApi.get_month_reserv_data(param);
    if (res.code === "200") {
      setGolfNoData(false);
      setReservationGolf(res.response.result as Reservation[]);
    } else if (res.code === "400") {
      setGolfNoData(true);
    } else {
      alert(`알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`);
    }
    setIsLoading(false);
  };

  const get_my_reservation2 = async () => {
    setIsLoading(true);

    const { formatmonthpk } = getFormattedDateTime();
    const userId = props.userState.userId;
    const pk = userId;
    const sk = formatmonthpk;
    const param: any = {
      pk: pk,
      sk: sk,
      reservState: "신청",
      reservFilter: "HEALTH",
    };
    const res = await mainApi.get_month_reserv_data(param);
    if (res.code === "200") {
      setHealthNoData(false);
      setReservationHealth(res.response.result as Reservation[]);
    } else if (res.code === "400") {
      setHealthNoData(true);
    } else {
      alert(`알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`);
    }
    setIsLoading(false);
  };

  const get_my_reservation3 = async () => {
    setIsLoading(true);
    const { formatmonthpk } = getFormattedDateTime();
    const userId = props.userState.userId;
    const pk = userId;
    const sk = formatmonthpk;
    const param: any = {
      pk: pk,
      sk: sk,
      reservState: "신청",
      reservFilter: "STUDY",
    };
    const res = await mainApi.get_month_reserv_data(param);
    if (res.code === "200") {
      setStudyNoData(false);
      setReservationStudy(res.response.result as Reservation[]);
    } else if (res.code === "400") {
      setStudyNoData(true);
    } else {
      alert(`알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`);
    }
    setIsLoading(false);
  };

  const get_my_reservation4 = async () => {
    setIsLoading(true);
    const { formatmonthpk } = getFormattedDateTime();
    const userId = props.userState.userId;
    const pk = userId;
    const sk = formatmonthpk;
    const param: any = {
      pk: pk,
      sk: sk,
      reservState: "신청",
      reservFilter: "LOCKER",
    };
    const res = await mainApi.get_month_reserv_data(param);
    if (res.code === "200") {
      setLockerNoData(false);
      setReservationLocker(res.response.result as Reservation[]);
    } else if (res.code === "400") {
      setLockerNoData(true);
    } else {
      alert(`알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`);
    }
    setIsLoading(false);
  };

  const diffDay = ["25", "26", "27", "28", "29", "30", "31"];
  const [allReservView, setAllReservView] = useState(false);
  const [isBulkReservationNoticeDismissed, setIsBulkReservationNoticeDismissed] = useState(false);
  const [highlightedNoticeKey, setHighlightedNoticeKey] = useState("");
  const noticeMonth = getFormattedDateTime().formatmonthpk;
  const noticeStorageKey = `hpoint.mobile.bulk-reservation.highlight.${props.userState.userId}`;
  const noticeKey = `${noticeStorageKey}:${noticeMonth}`;
  const bulkReservationMonth = (Number(noticeMonth.slice(-2)) % 12) + 1;
  const isBulkReservationNoticeVisible = allReservView && !isBulkReservationNoticeDismissed;
  const isBulkReservationHighlighted = isBulkReservationNoticeVisible && highlightedNoticeKey === noticeKey;

  useEffect(() => {
    const { formatday } = getFormattedDateTime();
    if (diffDay.includes(formatday)) {
      setAllReservView(true);
    }
  }, []);

  useEffect(() => {
    setHighlightedNoticeKey("");
    if (!isBulkReservationNoticeVisible || !props.userState.isAuth || !props.userState.userId ||
        isLoading || isBookLoading || !isReservationStatusReady) {
      return;
    }

    let finishTimer: ReturnType<typeof setTimeout> | undefined;
    // Wait for the loading backdrop's exit transition before consuming this month's notice.
    const startTimer = setTimeout(() => {
      try {
        if (window.localStorage.getItem(noticeStorageKey) === noticeMonth) return;
        window.localStorage.setItem(noticeStorageKey, noticeMonth);
      } catch {
        // Without a durable record, keep the ordinary card instead of repeating the highlight.
        return;
      }
      setHighlightedNoticeKey(noticeKey);
      finishTimer = setTimeout(() => setHighlightedNoticeKey(""), 3000);
    }, 300);

    return () => {
      clearTimeout(startTimer);
      if (finishTimer !== undefined) clearTimeout(finishTimer);
    };
  }, [isBulkReservationNoticeVisible, props.userState.isAuth, props.userState.userId,
    isLoading, isBookLoading, isReservationStatusReady,
    noticeMonth, noticeStorageKey, noticeKey]);

  const get_locker_info = async (lockerNum: string, reservPk: string) => {
    let tmepPk = "";
    if (lockerNum.startsWith("H")) {
      tmepPk = "HEALTH";
    } else if (lockerNum.startsWith("G")) {
      tmepPk = "GOLF";
    }

    const { formatday, formatmonthpk } = getFormattedDateTime();
    const checkMonth = reservPk.split("/");

    if (diffDay.includes(formatday)) {
      if (checkMonth[0] !== formatmonthpk) {
        if (lockerNum.startsWith("H")) {
          setLockerHPassword("준비중");
        } else if (lockerNum.startsWith("G")) {
          setLockerGPassword("준비중");
        }
        return;
      }
    }
    const pk = `LOCKER/${tmepPk}`;
    const sk = lockerNum;
    const param: any = {
      pk: pk,
      sk: sk,
    };

    const res = await mainApi.get_locker_list(param);
    if (res.code === "200") {
      if (lockerNum.startsWith("H")) {
        setLockerHPassword(`[${res.response.result[0]["PASSWORD"]}]`);
      } else if (lockerNum.startsWith("G")) {
        setLockerGPassword(`[${res.response.result[0]["PASSWORD"]}]`);
      }
    }
  };

  useEffect(() => {
    const loadReservationStatus = async () => {
      await Promise.allSettled([
        get_my_reservation1(),
        get_my_reservation2(),
        get_my_reservation3(),
        get_my_reservation4(),
      ]);
      setIsReservationStatusReady(true);
    };

    void loadReservationStatus();
  }, []);

  const fnScreenPage = () => {
    sendMainEntryClickLog("SCREEN_GOLF_MENU_CLICK", "/reservationscreen");
    navigate("/reservationscreen");
  };

  const allreserv = () => {
    setHighlightedNoticeKey("");
    navigate("/reservationnext");
  };

  const get_holiday_list = async () => {
    const pk = "COMMUNITY/BOOK";
    const sk = "NEWBOOK";
    const param: any = { pk, sk };

    const res = await mainApi.get_holiday_list(param);
    if (res.code === "200" && Array.isArray(res.response.result)) {
      const newSkList = res.response.result.flatMap((item: any) => item.book);
      return newSkList; // string[] 으로 반환됨
    } else {
      alert(`알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`);
      return [];
    }
  };

  const handleNewBookList = async (sklist: string[]) => {
    const pk = "book";

    // 각 SK에 대해 병렬 요청
    const promises = sklist.map((sk) => mainApi.get_book_new_list({ pk, sk }));

    const responses = await Promise.all(promises);
    console.log("responses : ", JSON.stringify(responses, null, 2));

    let allBooks = responses.flatMap((res) => {
      if (res.code === "200" && Array.isArray(res.response.result)) {
        return res.response.result.map((book: any) => ({
          title: book.title,
          author: book.author,
          image: book.image,
          badge: book.badge,
          tag: book.tag,
          description: book.description,
          url: book.url,
          maincopy: book.maincopy,
          isBorrowed: book.isBorrowed === true,
        }));
      } else if (res.code === "400") {
        toastRef.current?.open("잘못된 요청이 포함되어 있습니다.");
      }
      return [];
    });

    console.log("allBooks : ", JSON.stringify(allBooks, null, 2));
    setBookList(allBooks);
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        const sks = await get_holiday_list(); // 먼저 SK 목록 가져오기
        console.log("sks : ", sks);
        setSklist(sks); // 상태에도 저장 (원하면 사용)
        await handleNewBookList(sks); // 그걸로 책 리스트 요청
      } catch (e) {
        alert(`데이터 로딩 중 오류 발생: ${e}`);
      } finally {
        setIsBookLoading(false);
        setIsLoading(false);
      }
    };

    loadData(); // 초기 실행
  }, []);

  const reservationGroups = [
    {
      id: "health",
      label: "헬스장",
      image: "/images/main_02.png",
      missionImage: "/images/hpoint-renewal/objects-3d/fitness-treadmill-hero.png",
      unreservedMissionImage: "/images/hpoint-renewal/objects-3d/fitness-treadmill-hero-unreserved.png",
      displayOrder: 1,
      noData: healthNoData,
      reservations: reservationHealth,
    },
    {
      id: "golf",
      label: "골프 연습장",
      image: "/images/main_03.png",
      missionImage: "/images/hpoint-renewal/objects-3d/golf-reservation-hero.png",
      unreservedMissionImage: "/images/hpoint-renewal/objects-3d/golf-reservation-hero-unreserved.png",
      displayOrder: 0,
      noData: golfNoData,
      reservations: reservationGolf,
    },
    {
      id: "study",
      label: "독서실",
      image: "/images/main_04.png",
      missionImage: "/images/hpoint-renewal/objects-3d/study-books-hero.png",
      unreservedMissionImage: "/images/hpoint-renewal/objects-3d/study-books-hero-unreserved.png",
      displayOrder: 3,
      noData: studyNoData,
      reservations: reservationStudy,
    },
    {
      id: "locker",
      label: "락커",
      image: "/images/main_05.png",
      missionImage: "/images/hpoint-renewal/objects-3d/locker-hero.png",
      unreservedMissionImage: "/images/hpoint-renewal/objects-3d/locker-hero-unreserved.png",
      displayOrder: 2,
      noData: lockerNoData,
      reservations: reservationLocker,
    },
  ];
  const orderedReservationGroups = [...reservationGroups].sort(
    (left, right) => Number(left.noData) - Number(right.noData) || left.displayOrder - right.displayOrder
  );
  const currentReservationMonth = getFormattedDateTime().formatmonthpk;

  const getReservationMonth = (reservData: Reservation, details: ReservationDetails) => {
    const reservationMonth = reservData.pk.split("/")[0];
    if (/^\d{6}$/.test(reservationMonth)) {
      return reservationMonth;
    }

    const reservationDateMatch = details.reservDt.match(/(\d{4})년\s*(\d{1,2})월/);
    if (!reservationDateMatch) {
      return "";
    }

    return `${reservationDateMatch[1]}${reservationDateMatch[2].padStart(2, "0")}`;
  };

  const getReservationStatusLabel = (reservData: Reservation, details: ReservationDetails) => {
    const reservationMonth = getReservationMonth(reservData, details);
    if (reservationMonth > currentReservationMonth) {
      return `${Number(reservationMonth.slice(4, 6))}월 신청완료`;
    }

    return "이용 중";
  };

  const getLockerReservationOrder = (reservData: Reservation) => {
    const lockerNumber = Object.values(reservData.reservInfo.reservations)[0]?.reservOption;

    if (lockerNumber?.includes("G")) return 0;
    if (lockerNumber?.includes("H")) return 1;
    return 2;
  };

  const renderInbodyBadge = () => (
    <Button
      className="hp-mobile-home__mission-inbody-badge"
      onClick={() => navigate("/mobileinbody")}
      title="인바디 카탈로그"
      aria-label="인바디"
    >
      <span className="hp-mobile-home__mission-inbody-badge-mark" aria-hidden="true">
        !
      </span>
      인바디
    </Button>
  );

  const renderHealthRollingMessages = () => (
    <div className="hp-mobile-home__health-rolling" aria-label="운동 안내">
      <div className="hp-mobile-home__health-rolling-track">
        {HEALTH_ROLLING_MESSAGES.map((message) => (
          <span key={message}>{message}</span>
        ))}
        <span aria-hidden="true">{HEALTH_ROLLING_MESSAGES[0]}</span>
      </div>
    </div>
  );

  const getLockerPassword = (reservOption: string) => {
    if (reservOption.startsWith("H")) {
      return lockerHPassword;
    }

    if (reservOption.startsWith("G")) {
      return lockerGPassword;
    }

    return "";
  };

  const getLockerLabel = (reservOption: string) => {
    if (reservOption.startsWith("H")) {
      return "헬스장 락커";
    }

    if (reservOption.startsWith("G")) {
      return "골프장 락커";
    }

    return "락커";
  };

  const renderReservationActions = (facility: string, details: ReservationDetails, reservData: Reservation) => {
    if (facility === "health") {
      return null;
    }

    if (facility === "golf") {
      return (
        <Button className="hp-mobile-home__entry-action hp-mobile-home__entry-action--plain" onClick={fnScreenPage}>
          스크린 예약
        </Button>
      );
    }

    if (facility === "study") {
      return null;
    }

    const lockerPassword = getLockerPassword(details.reservOption);

    return (
      <Button
        className="hp-mobile-home__entry-action hp-mobile-home__entry-action--plain"
        onClick={() => get_locker_info(details.reservOption, reservData.pk)}
      >
        {lockerPassword || "패스워드 확인"}
      </Button>
    );
  };

  return (
    <>
      <main className="hpoint-renewal hp-mobile-home">
        {isBulkReservationHighlighted && (
          <button
            className="hp-mobile-home__notice-backdrop"
            type="button"
            aria-label="일괄예약 강조 닫기"
            onClick={() => setHighlightedNoticeKey("")}
          />
        )}
        <header
          className={`hp-mobile-home__hero ${
            isBulkReservationNoticeVisible ? "hp-mobile-home__hero--with-notice" : ""
          }`}
          aria-labelledby="mission-hero-title"
        >
          {isBulkReservationNoticeVisible && (
            <div className={`hp-mobile-home__hero-notice${
              isBulkReservationHighlighted ? " hp-mobile-home__hero-notice--highlight" : ""
            }`}>
              <button className="hp-mobile-home__hero-notice-action" type="button" onClick={allreserv}>
                <img
                  className="hp-mobile-home__hero-notice-icon"
                  src="/images/hpoint-renewal/icons/monthly-reservation-calendar.png"
                  alt="일괄예약 달력"
                />
                <span className="hp-mobile-home__hero-notice-copy">
                  <strong className="hp-mobile-home__hero-notice-title">
                    {bulkReservationMonth}월 예약이 시작되었습니다.
                  </strong>
                  <span className="hp-mobile-home__hero-notice-description">일괄예약 하시겠습니까?</span>
                </span>
              </button>
              <button
                className="hp-mobile-home__hero-notice-close"
                type="button"
                aria-label="일괄예약 카드 닫기"
                onClick={() => setIsBulkReservationNoticeDismissed(true)}
              >
                ×
              </button>
            </div>
          )}
          <div className="hp-mobile-home__hero-copy">
            <h1 id="mission-hero-title" className="hp-mobile-home__hero-title">
              디에트르 라포레
            </h1>
            <p className="hp-mobile-home__hero-description">커뮤니티센터 예약 사이트</p>
          </div>
          <img
            className="hp-mobile-home__hero-illustration"
            src={communityCenterHeroImage}
            alt="커뮤니티센터 일러스트"
          />
        </header>

        <section className="hp-mobile-home__mission-section" aria-labelledby="community-status-heading">
          <h2 id="community-status-heading" className="hp-mobile-home__mission-heading">
            내 커뮤니티 이용 현황
          </h2>
          <div className="hp-mobile-home__mission-carousel">
            <ul className="hp-mobile-home__mission-list" aria-busy={!isReservationStatusReady}>
              {!isReservationStatusReady
                ? [0, 1].map((index) => (
                    <li
                      className="hp-mobile-home__mission-card hp-mobile-home__mission-card--skeleton"
                      key={`reservation-status-skeleton-${index}`}
                      aria-hidden="true"
                    >
                      <Skeleton className="hp-mobile-home__mission-skeleton hp-mobile-home__mission-skeleton--tag" />
                      <Skeleton className="hp-mobile-home__mission-skeleton hp-mobile-home__mission-skeleton--title" />
                      <Skeleton className="hp-mobile-home__mission-skeleton hp-mobile-home__mission-skeleton--illustration" />
                      <Skeleton className="hp-mobile-home__mission-skeleton hp-mobile-home__mission-skeleton--action" />
                    </li>
                  ))
                : orderedReservationGroups.flatMap((group) => {
                    if (group.noData) {
                      return [
                        <li
                          className={`hp-mobile-home__mission-card hp-mobile-home__mission-card--inactive hp-mobile-home__mission-card--${group.id}`}
                          key={group.id}
                        >
                          <span className="hp-mobile-home__mission-tag">미신청</span>
                          <div
                            className={`hp-mobile-home__mission-facility ${
                              group.id === "health" ? "hp-mobile-home__mission-facility--health" : ""
                            }`}
                          >
                            <strong>{group.label}</strong>
                            {group.id === "health" && renderInbodyBadge()}
                          </div>
                          <img
                            className="hp-mobile-home__mission-illustration"
                            src={group.unreservedMissionImage}
                            alt=""
                          />
                          <div className="hp-mobile-home__mission-card-footer" aria-hidden="true" />
                        </li>,
                      ];
                    }

                    const orderedReservations =
                      group.id === "locker"
                        ? [...group.reservations].sort(
                            (left, right) => getLockerReservationOrder(left) - getLockerReservationOrder(right)
                          )
                        : group.reservations;

                    return orderedReservations.flatMap((reservData, reservationIndex) =>
                      Object.entries(reservData.reservInfo.reservations).map(([slot, details]) => (
                        <li
                          className={`hp-mobile-home__mission-card hp-mobile-home__mission-card--${group.id}`}
                          key={`${group.id}-${reservationIndex}-${slot}`}
                        >
                          <span className="hp-mobile-home__mission-tag">
                            {getReservationStatusLabel(reservData, details)}
                          </span>
                          <div
                            className={`hp-mobile-home__mission-facility ${
                              group.id === "locker"
                                ? "hp-mobile-home__mission-facility--locker"
                                : group.id === "study"
                                ? "hp-mobile-home__mission-facility--study"
                                : group.id === "health"
                                ? "hp-mobile-home__mission-facility--health"
                                : ""
                            }`}
                          >
                            <strong>
                              {group.id === "locker" ? getLockerLabel(details.reservOption) : group.label}
                            </strong>
                            {group.id === "locker" && (
                              <span className="hp-mobile-home__mission-locker-number">{details.reservOption}</span>
                            )}
                            {group.id === "study" && (
                              <span className="hp-mobile-home__mission-study-seat">{details.reservOption}</span>
                            )}
                            {group.id === "health" && renderInbodyBadge()}
                          </div>
                          <img className="hp-mobile-home__mission-illustration" src={group.missionImage} alt="" />
                          <div className="hp-mobile-home__mission-card-footer">
                            {group.id === "health" ? (
                              renderHealthRollingMessages()
                            ) : (
                              <div className="hp-mobile-home__mission-actions">
                                {renderReservationActions(group.id, details, reservData)}
                              </div>
                            )}
                          </div>
                        </li>
                      ))
                    );
                  })}
            </ul>
          </div>
        </section>

        <section className="hp-mobile-home__price-guide-section" aria-label="커뮤니티 둘러보기">
          <Box
            component={RouterLink}
            to="/mobilecommunityinfo"
            className="hp-mobile-home__price-guide-card"
            aria-label="커뮤니티센터 둘러보기"
          >
            <span className="hp-mobile-home__price-guide-visual" aria-hidden="true">
              <GroupsRoundedIcon />
              <span>+</span>
            </span>
            <span className="hp-mobile-home__price-guide-copy">
              <strong>커뮤니티 둘러보기</strong>
              <span>남녀노소 즐기는 우리 단지 시설을 만나보세요</span>
            </span>
            <ArrowForwardIosIcon className="hp-mobile-home__price-guide-arrow" aria-hidden="true" />
          </Box>
        </section>

        <section
          className="hp-mobile-home__section hp-mobile-home__community-application-section"
          aria-labelledby="community-application-heading"
        >
          <div className="hp-mobile-home__section-header">
            <h2 id="community-application-heading" className="hp-section-heading">
              커뮤니티 신청
            </h2>
            <span className="hp-mobile-home__section-caption">시설 선택</span>
          </div>
          <div className="hp-mobile-home__quick-grid">
            {icons.map((item) => (
              <Box key={item.label} component={RouterLink} to={item.to} className="hp-mobile-home__quick-link">
                <span className="hp-mobile-home__quick-icon">
                  <Avatar src={item.src} variant="square" />
                </span>
                <span className="hp-mobile-home__quick-label">{item.label}</span>
              </Box>
            ))}
          </div>
          {bookList.length ? (
            <section className="hp-mobile-home__new-book-section" aria-labelledby="new-book-heading">
              <RouterLink
                to={SMALL_LIBRARY_PATH}
                onClick={() => sendMainEntryClickLog(SMALL_LIBRARY_EVENT_TYPE, SMALL_LIBRARY_PATH)}
                className="hp-mobile-home__new-book-header"
                aria-label="작은도서관 신간 전체 보기"
              >
                <Typography id="new-book-heading" component="h3" className="hp-mobile-home__new-book-heading">
                  작은도서관 신간 소개
                </Typography>
                <ArrowForwardIosIcon aria-hidden="true" />
              </RouterLink>
              <ul className="hp-mobile-home__new-book-list">
                {bookList.map((book, index) => (
                  <li key={`${book.title}-${book.url ?? index}`}>
                    <RouterLink
                      to={SMALL_LIBRARY_PATH}
                      onClick={() => sendMainEntryClickLog(SMALL_LIBRARY_EVENT_TYPE, SMALL_LIBRARY_PATH)}
                      className="hp-mobile-home__new-book-card"
                      aria-label={`${book.title} 신간 자세히 보기`}
                    >
                      <span className="hp-mobile-home__new-book-card-visual">
                        <img src={book.image} alt="" />
                        {book.isBorrowed ? <span className="hp-book-borrowed-badge">대여중</span> : null}
                      </span>
                      <span className="hp-mobile-home__new-book-card-copy">
                        <strong>{book.title}</strong>
                        <span>{book.author || "작은도서관 신간"}</span>
                      </span>
                    </RouterLink>
                  </li>
                ))}
              </ul>
            </section>
          ) : isBookLoading ? (
            <div className="hp-mobile-home__new-book-skeleton" role="status" aria-label="도서 추천 불러오는 중">
              {[0, 1].map((index) => (
                <Skeleton key={index} variant="rounded" animation="wave" />
              ))}
            </div>
          ) : null}

          <Card
            elevation={0}
            className="hp-mobile-home__promo-card hp-mobile-home__promo-card--robot hp-mobile-home__robot-feature-card"
          >
            <CardActionArea
              component={RouterLink}
              to={ROBOT_CLEANER_PATH}
              onClick={() => sendMainEntryClickLog("ROBOT_CLEANER_MENU_CLICK", ROBOT_CLEANER_PATH)}
              className="hp-mobile-home__promo-action hp-mobile-home__robot-feature-action"
              aria-label="창문 로봇청소기 예약하기"
            >
              <span className="hp-mobile-home__robot-feature-accessible-copy">
                <span>{robotCleanerBadgeText}</span>
                <span>6박 7일 대여</span>
              </span>
              <span className="hp-mobile-home__robot-feature-copy">
                <span className="hp-mobile-home__robot-feature-badge">6박 7일</span>
                <strong className="hp-mobile-home__robot-feature-title">창문 로봇청소기 예약</strong>
              </span>
              <span className="hp-mobile-home__robot-feature-composition" aria-hidden="true">
                <img
                  className="hp-mobile-home__robot-feature-con-area"
                  src="/images/hpoint-renewal/banners/window-cleaning-banner.svg"
                  alt=""
                />
                <img
                  className="hp-mobile-home__robot-feature-window"
                  src="/images/hpoint-renewal/banners/window-cleaning-banner-window.png"
                  alt=""
                />
                <img
                  className="hp-mobile-home__robot-feature-item"
                  src="/images/hpoint-renewal/objects-3d/window-robot-cleaner-hero.png"
                  alt=""
                />
              </span>
              <span className="hp-mobile-home__robot-feature-cta" aria-hidden="true">
                <svg viewBox="0 0 32 32" focusable="false">
                  <path d="m20 10-6 6 6 6M15 10l-6 6 6 6M25 10l-6 6 6 6" />
                </svg>
              </span>
            </CardActionArea>
          </Card>
        </section>
      </main>

      <MobileMainFooter userState={props.userState} />

      <Toast ref={toastRef} />
      <LoadingCircle loading={isLoading} />
    </>
  );
};

export default MobileMainPage;
